<template>
  <div class="row">
    <div class="col">
      <Button @click="rechercher"> Rechercher </Button>
    </div>
    <div class="col">
      <Button @click="redirectionAjouterPays"> Ajouter </Button>
    </div>
    <div class="col">
      <Button @click="fermer"> Fermer </Button>
    </div>
  </div>
</template>

<script>
export default {
  emits: ['rechercher'],
  methods: {
    redirectionAjouterPays() {
      this.$router.push({name: 'ajouterPaysPilotage'});
    },
    rechercher(){
      this.$emit('rechercher');
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    }
  }
}
</script>
